import { combineReducers } from 'redux';
import details from 'views/DashboardSettings_Details/flow/reducer';

export default combineReducers({
  details
});



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/flow/reducer.js